export default __webpack_public_path__ + "static/media/broker.43f7f3ac.svg";